 import { TypeDoctorId } from './types/TypesDocsId';
// import parse, { DOMNode, Element } from 'html-react-parser';
// import { baseURL } from '@/lib/servies/axiosConfig';
// import { formatNameDoctor } from '@/constant/scripts';
// import { IoAlertCircleOutline } from 'react-icons/io5';
// import DoctorNav from './DoctorNav';
// import Main from './main/main';

export default function ProfileDoctor({}: // profileData,
// faq,
// itemsAbout,
TypeDoctorId) {
    // const { name, bio, id, per_visit, lat, lng } = profileData;

    // const doctorUrl = `${baseURL.substring(
    //     0,
    //     baseURL.length - 2,
    // )}/doctor/${id}/${formatNameDoctor(name)}`;
    return <div className="w-full flex flex-col gap-3"></div>;
}
